import type { LucideIcon } from "lucide-react"
import { Card, CardContent } from "@/components/ui/card"
import { cn } from "@/lib/utils"

export type KpiAccent = "blue" | "green" | "amber" | "violet"

interface Props {
  label: string
  value: string
  subtitle: string
  icon: LucideIcon
  accent: KpiAccent
}

const ACCENT_CLASS: Record<KpiAccent, string> = {
  blue: "bg-sky-50 text-sky-600 ring-1 ring-sky-100",
  green: "bg-emerald-50 text-emerald-600 ring-1 ring-emerald-100",
  amber: "bg-amber-50 text-amber-600 ring-1 ring-amber-100",
  violet: "bg-violet-50 text-violet-600 ring-1 ring-violet-100",
}

export function KpiCard({ label, value, subtitle, icon: Icon, accent }: Props) {
  return (
    <Card className="transition-shadow hover:shadow-md">
      <CardContent className="flex items-start justify-between gap-4">
        <div className="space-y-1.5 min-w-0">
          <p className="text-[11px] font-semibold uppercase tracking-[0.06em] text-slate-500">
            {label}
          </p>
          <p className="text-3xl font-bold tracking-tight text-slate-900 tabular-nums">
            {value}
          </p>
          <p className="text-xs text-slate-500">{subtitle}</p>
        </div>
        <div className={cn("rounded-xl p-2.5 shrink-0", ACCENT_CLASS[accent])}>
          <Icon className="size-5" />
        </div>
      </CardContent>
    </Card>
  )
}
